/**
 * Gemeinsamer Rahmen für alles, was VOR dem Portal steht: Anmeldung und der
 * erzwungene Passwortwechsel (ADR 0085). Beide sollen gleich aussehen — ein
 * Partner, der gerade sein Passwort setzt, ist noch im Anmeldevorgang und soll
 * nicht plötzlich in einer anderen Optik landen.
 */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <div className="w-full max-w-sm">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">PROBIG</p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
        <div className="mt-7">{children}</div>
      </div>
    </main>
  );
}

/** Fehlermeldung im Formular — nie stillschweigend schlucken (CLAUDE.md §9). */
export function ErrorNote({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">
      {message}
    </p>
  );
}
